import gql from 'graphql-tag';

export const UpdatePharmacyMutation = gql`
  mutation UpdatePharmacy($data: UpdatePharmacyInput!) {
    updatePharmacy(data: $data) {
      ncpdp
    }
  }
`;
